import Cookies from 'js-cookie';
import { 
  CONFIG_ENVIRONMENT,
  COOKIE_IDENTIFIER_DEBUG
} from '../config';

/* eslint-disable @typescript-eslint/no-explicit-any */

export interface LogAppender {
  debug?: (...args: any[]) => void;
  info?: (...args: any[]) => void;
  warn?: (...args: any[]) => void;
  error?: (...args: any[]) => void;
}

export enum LogLevels {
  verbose,
  info,
  warnings,
  errors
}

const consoleAppender: LogAppender = {
  debug: (...args) => {
    window.console.debug(...args);
  },
  info: (...args) => {
    window.console.info(...args);
  },
  warn: (...args) => {
    window.console.warn(...args);
  },
  error: (...args) => {
    window.console.error(...args);
  },
};

const appenders: LogAppender[] = [consoleAppender];

export function registerAppender(appender: LogAppender): void {
  appenders.push(appender);
}

let logLevel: LogLevels;

// The value of CONFIG_ENVIRONMENT is replaced at build time which confuses tsc so we have to ts-ignore it
switch(CONFIG_ENVIRONMENT) {
  /* istanbul ignore next case */
  case ('PRODUCTION' as string):
    logLevel = LogLevels.errors;
    break;
  default:
    logLevel = LogLevels.verbose;
}

export function debug(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.verbose && Cookies.get(COOKIE_IDENTIFIER_DEBUG) === 'true') {
    appenders
      .filter((appender) => typeof appender.debug === 'function')
      .forEach((appender) => {
        appender.debug(`[TCF]->`, ...args);
      });
  }
}

export function info(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.info && Cookies.get(COOKIE_IDENTIFIER_DEBUG) === 'true') {
    appenders
      .filter((appender) => typeof appender.info === 'function')
      .forEach((appender) => {
        appender.info(`[TCF]->`, ...args);
      });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function warn(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.warnings && Cookies.get(COOKIE_IDENTIFIER_DEBUG) === 'true') {
    appenders
      .filter((appender) => typeof appender.warn === 'function')
      .forEach((appender) => {
        appender.warn(`[TCF]->`, ...args);
      });
  }
}

export function error(...args: any[]): void {
  /* istanbul ignore next else */
  if (logLevel <= LogLevels.errors) {
    appenders
      .filter((appender) => typeof appender.error === 'function')
      .forEach((appender) => {
        appender.error(`[TCF]->`, ...args);
      });
  }
}
